//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './ProfileClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

    
export function getDoctorProfileInfoUrl(): string {
  let url_ = getBaseUrl() + "/api/profile/doctor";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDoctorProfileInfoDefaultOptions: UseQueryOptions<Types.DoctorProfileDto, unknown, Types.DoctorProfileDto> = {
  queryFn: __getDoctorProfileInfo,
};
export function getGetDoctorProfileInfoDefaultOptions(): UseQueryOptions<Types.DoctorProfileDto, unknown, Types.DoctorProfileDto> {
  return getDoctorProfileInfoDefaultOptions;
};
export function setGetDoctorProfileInfoDefaultOptions(options: UseQueryOptions<Types.DoctorProfileDto, unknown, Types.DoctorProfileDto>) {
  getDoctorProfileInfoDefaultOptions = options;
}

export function getDoctorProfileInfoQueryKey(): QueryKey;
export function getDoctorProfileInfoQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'ProfileClient',
      'getDoctorProfileInfo',
    ]);
}
function __getDoctorProfileInfo() {
  return Client.getDoctorProfileInfo(
    );
}

/**
 * Returns short information about Doctor profile
 */
export function useGetDoctorProfileInfoQuery<TSelectData = Types.DoctorProfileDto, TError = unknown>(options?: UseQueryOptions<Types.DoctorProfileDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDoctorProfileInfoQuery<TSelectData = Types.DoctorProfileDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DoctorProfileDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.DoctorProfileDto, TError, TSelectData>({
    queryFn: __getDoctorProfileInfo,
    queryKey: getDoctorProfileInfoQueryKey(),
    ...getDoctorProfileInfoDefaultOptions as unknown as UseQueryOptions<Types.DoctorProfileDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns short information about Doctor profile
 */
export function setGetDoctorProfileInfoData(queryClient: QueryClient, updater: (data: Types.DoctorProfileDto | undefined) => Types.DoctorProfileDto, ) {
  queryClient.setQueryData(getDoctorProfileInfoQueryKey(),
    updater
  );
}

/**
 * Returns short information about Doctor profile
 */
export function setGetDoctorProfileInfoDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DoctorProfileDto | undefined) => Types.DoctorProfileDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getPatientProfileInfoUrl(): string {
  let url_ = getBaseUrl() + "/api/profile/patient";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientProfileInfoDefaultOptions: UseQueryOptions<Types.PatientDto, unknown, Types.PatientDto> = {
  queryFn: __getPatientProfileInfo,
};
export function getGetPatientProfileInfoDefaultOptions(): UseQueryOptions<Types.PatientDto, unknown, Types.PatientDto> {
  return getPatientProfileInfoDefaultOptions;
};
export function setGetPatientProfileInfoDefaultOptions(options: UseQueryOptions<Types.PatientDto, unknown, Types.PatientDto>) {
  getPatientProfileInfoDefaultOptions = options;
}

export function getPatientProfileInfoQueryKey(): QueryKey;
export function getPatientProfileInfoQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'ProfileClient',
      'getPatientProfileInfo',
    ]);
}
function __getPatientProfileInfo() {
  return Client.getPatientProfileInfo(
    );
}

/**
 * Returns short information about patient profile
 */
export function useGetPatientProfileInfoQuery<TSelectData = Types.PatientDto, TError = unknown>(options?: UseQueryOptions<Types.PatientDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientProfileInfoQuery<TSelectData = Types.PatientDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PatientDto, TError, TSelectData>({
    queryFn: __getPatientProfileInfo,
    queryKey: getPatientProfileInfoQueryKey(),
    ...getPatientProfileInfoDefaultOptions as unknown as UseQueryOptions<Types.PatientDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns short information about patient profile
 */
export function setGetPatientProfileInfoData(queryClient: QueryClient, updater: (data: Types.PatientDto | undefined) => Types.PatientDto, ) {
  queryClient.setQueryData(getPatientProfileInfoQueryKey(),
    updater
  );
}

/**
 * Returns short information about patient profile
 */
export function setGetPatientProfileInfoDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientDto | undefined) => Types.PatientDto) {
  queryClient.setQueryData(queryKey, updater);
}